import { motion } from "framer-motion";
import { Eye, MousePointerClick, Globe } from "lucide-react";
import { ComparisonBadge } from "../compare/ComparisonBadge";
import { rangeLabel } from "../compare/headlineTotals";

const fmt = (n) => {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return Math.round(n).toLocaleString();
};

const TILES = [
  { key: "impressions", label: "Times your brand was seen", icon: Eye, tone: "text-lime-300" },
  { key: "clicks", label: "Ad clicks", icon: MousePointerClick, tone: "text-cyan-300" },
  { key: "visits", label: "Website visits", icon: Globe, tone: "text-teal-300" },
];

export const ShowingUpScoreboard = ({ current, previous }) => {
  const tiles = TILES.filter((t) => current[t.key] > 0);
  if (!tiles.length) return null;
  return (
    <div className="mb-8 md:mb-10" data-testid="showing-up-scoreboard">
      <div className={`grid grid-cols-1 ${["", "", "sm:grid-cols-2", "sm:grid-cols-3"][tiles.length]} gap-3 md:gap-4`}>
        {tiles.map((t, i) => (
          <motion.div
            key={t.key}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * i, duration: 0.4 }}
            className="bg-[#0c465f] rounded-2xl ring-1 ring-white/10 p-4 md:p-6 transition-transform duration-300 hover:-translate-y-0.5"
            data-testid={`scoreboard-${t.key}`}
          >
            <t.icon className={`hidden sm:block w-5 h-5 ${t.tone} mb-3`} />
            <p className={`text-3xl md:text-5xl font-black tabular-nums leading-none ${t.tone}`} data-testid={`scoreboard-${t.key}-value`}>
              {fmt(current[t.key])}
            </p>
            <p className="text-slate-300 text-sm mt-2">{t.label}</p>
            {previous && (
              <div className="mt-3">
                <ComparisonBadge current={current[t.key]} previous={previous.totals[t.key]} testId={`compare-${t.key}`} />
              </div>
            )}
          </motion.div>
        ))}
      </div>
      {previous && tiles.some((t) => current[t.key] > 0 && previous.totals[t.key] > 0) && (
        <p className="text-cyan-100/50 text-xs mt-3" data-testid="previous-period-range">
          Previous period: {rangeLabel(previous.range)}
        </p>
      )}
    </div>
  );
};
